import { createContext, useContext, useEffect, useState } from "react";

const I18nContext = createContext(null);

const TRANSLATIONS = {
  fr: {
    home: "Accueil", shop: "Boutique", categories: "Catégories", products: "Produits",
    help: "Aide", contact: "Contact", account: "Compte", myAccount: "Mon compte",
    login: "Se connecter", register: "Créer un compte", logout: "Déconnexion",
    favorites: "Favoris", compare: "Comparer", cart: "Panier",
    search: "Rechercher un produit...", searchBtn: "Rechercher",
    allCategories: "Toutes les catégories", allCategoriesDropdown: "Toutes catégories",
    tracking: "Suivi", trackingOrder: "Suivi de commande",
    locateStore: "Localiser un magasin", faq: "FAQ",
    saleBanner: "Soldes −20% sur produits sélectionnés",
    inStock: "En stock", outOfStock: "Rupture",
    addToCart: "Ajouter au panier", buyNow: "Acheter maintenant",
    viewAll: "Voir tout", viewOffer: "Voir l'offre", discover: "Découvrir",
    profile: "Profil", addresses: "Adresses", password: "Mot de passe",
    orders: "Commandes", editProfile: "Modifier le profil",
    changePassword: "Changer le mot de passe", currentPassword: "Mot de passe actuel",
    newPassword: "Nouveau mot de passe", save: "Enregistrer", cancel: "Annuler",
    fullName: "Nom complet", phone: "Téléphone", city: "Ville", department: "Département",
    address: "Adresse", notes: "Notes", defaultAddress: "Adresse par défaut",
    addAddress: "Ajouter une adresse", edit: "Modifier", delete: "Supprimer",
    photo: "Photo", uploadPhoto: "Changer la photo",
    hotDeals: "Hot Deals", featuredProducts: "Featured Products", topSelling: "Top Selling Products",
    saveUpTo: "Économisez jusqu'à", offerEndsIn: "Fin de l'offre dans :",
    days: "Jours", hours: "H", minutes: "M", seconds: "S",
    specialOffer: "Offre spéciale", bestSellers: "Best-sellers",
    checkout: "Commander", subtotal: "Sous-total", total: "Total", deliveryFee: "Frais de livraison",
    placeOrder: "Confirmer la commande", promoCode: "Code promo", apply: "Appliquer",
    orderConfirmed: "Commande confirmée !",
    newArrival: "Nouveau arrivage", promo: "Promo", new: "Nouveau",
    bestSeller: "Best-seller", ourStore: "Notre marketplace haïtienne pour l'électronique, l'électroménager et l'énergie solaire.",
    pages: "Pages", info: "Informations", aboutUs: "À propos de nous", contactUs: "Contactez-nous",
    helpCenter: "Centre d'aide", securityCenter: "Centre de sécurité", becomePartner: "Devenir partenaire JE",
    shippingInfo: "Informations de livraison", returnPolicy: "Politique de retour & remboursement",
    reportSuspicious: "Signaler une activité suspecte", myAccountFooter: "Mon compte", allRightsReserved: "Tous droits réservés",
    questionWhatsapp: "Une question ? Discutons sur WhatsApp",
    teamAnswer: "Notre équipe répond du lundi au samedi, 8h-18h",
    contactWhatsapp: "Nous contacter sur WhatsApp",
    products: "Produits", productsCount: "Produits", reviews: "avis",
    remove: "Retirer", quantity: "Quantité", emptyCart: "Votre panier est vide",
    startShopping: "Découvrir les produits", cartSummary: "Récapitulatif",
    goToCheckout: "Passer à la caisse", myCart: "Mon panier",
    shippingAddress: "Adresse de livraison", payment: "Paiement",
    yourOrder: "Votre commande", processing: "Traitement…",
    saveOn: "Économisez sur vos produits favoris",
    hero1Title: "iPhone 15 Pro Max", hero1Sub: "Puissance ultime. Système photo Pro 48 Mpx.",
    hero2Title: "Batteries Lithium", hero2Sub: "6000 cycles. Autonomie premium.",
    hero3Title: "Panneaux 450W", hero3Sub: "Autonomie complète pour votre maison.",
    promoActive: "Promos actives", saveUp20: "Économisez jusqu'à 20%",
    salesClientPick: "La sélection des clients",
    delivery24: "Livraison Immédiate 24h", deliveryGonaives: "Recevez vos produits en 24h à Gonaïves",
    freeShipping: "Livraison rapide partout en Haïti", trustedSupport: "Support WhatsApp 7j/7",
    limitedOffer: "Seulement pour quelques jours ! Profitez de nos promotions exceptionnelles.",
    discoverOffers: "Découvrez les offres →",
  },
  en: {
    home: "Home", shop: "Shop", categories: "Categories",
    help: "Help", contact: "Contact", account: "Account", myAccount: "My Account",
    login: "Sign in", register: "Create account", logout: "Sign out",
    favorites: "Favorites", compare: "Compare", cart: "Cart",
    search: "Search a product...", searchBtn: "Search",
    allCategories: "All categories", allCategoriesDropdown: "All categories",
    tracking: "Tracking", trackingOrder: "Order tracking",
    locateStore: "Locate a store", faq: "FAQ",
    saleBanner: "Sale −20% on selected products",
    inStock: "In stock", outOfStock: "Out of stock",
    addToCart: "Add to cart", buyNow: "Buy now",
    viewAll: "View all", viewOffer: "View offer", discover: "Discover",
    profile: "Profile", addresses: "Addresses", password: "Password",
    orders: "Orders", editProfile: "Edit profile",
    changePassword: "Change password", currentPassword: "Current password",
    newPassword: "New password", save: "Save", cancel: "Cancel",
    fullName: "Full name", phone: "Phone", city: "City", department: "Department",
    address: "Address", notes: "Notes", defaultAddress: "Default address",
    addAddress: "Add an address", edit: "Edit", delete: "Delete",
    photo: "Photo", uploadPhoto: "Change photo",
    hotDeals: "Hot Deals", featuredProducts: "Featured Products", topSelling: "Top Selling Products",
    saveUpTo: "Save up to", offerEndsIn: "Offer ends in:",
    days: "Days", hours: "H", minutes: "M", seconds: "S",
    specialOffer: "Special offer", bestSellers: "Best-sellers",
    checkout: "Checkout", subtotal: "Subtotal", total: "Total", deliveryFee: "Delivery fee",
    placeOrder: "Place order", promoCode: "Promo code", apply: "Apply",
    orderConfirmed: "Order confirmed!",
    newArrival: "New arrival", promo: "Promo", new: "New",
    bestSeller: "Best-seller", ourStore: "Your Haitian marketplace for electronics, appliances and solar energy.",
    pages: "Pages", info: "Information", aboutUs: "About us", contactUs: "Contact us",
    helpCenter: "Help center", securityCenter: "Security center", becomePartner: "Become a JE partner",
    shippingInfo: "Shipping information", returnPolicy: "Return & refund policy",
    reportSuspicious: "Report suspicious activity", myAccountFooter: "My account", allRightsReserved: "All rights reserved",
    questionWhatsapp: "Any question? Let's chat on WhatsApp",
    teamAnswer: "Our team answers Monday to Saturday, 8am-6pm",
    contactWhatsapp: "Contact us on WhatsApp",
    products: "Products", productsCount: "Products", reviews: "reviews",
    remove: "Remove", quantity: "Quantity", emptyCart: "Your cart is empty",
    startShopping: "Discover products", cartSummary: "Summary",
    goToCheckout: "Go to checkout", myCart: "My cart",
    shippingAddress: "Shipping address", payment: "Payment",
    yourOrder: "Your order", processing: "Processing…",
    saveOn: "Save on your favorite products",
    hero1Title: "iPhone 15 Pro Max", hero1Sub: "Ultimate power. Pro 48MP photo system.",
    hero2Title: "Lithium Batteries", hero2Sub: "6000 cycles. Premium autonomy.",
    hero3Title: "450W Panels", hero3Sub: "Full autonomy for your home.",
    promoActive: "Active promos", saveUp20: "Save up to 20%",
    salesClientPick: "Customers' selection",
    delivery24: "Express delivery 24h", deliveryGonaives: "Receive your products in 24h in Gonaïves",
    freeShipping: "Fast delivery all over Haiti", trustedSupport: "WhatsApp support 7 days/week",
    limitedOffer: "For a limited time! Take advantage of our exceptional promotions.",
    discoverOffers: "Discover offers →",
  },
  ht: {
    home: "Akèy", shop: "Boutik", categories: "Kategori",
    help: "Èd", contact: "Kontak", account: "Kont", myAccount: "Kont mwen",
    login: "Konekte", register: "Kreye yon kont", logout: "Dekonekte",
    favorites: "Favori", compare: "Konpare", cart: "Pànye",
    search: "Chèche yon pwodwi...", searchBtn: "Chèche",
    allCategories: "Tout kategori", allCategoriesDropdown: "Tout kategori",
    tracking: "Swiv", trackingOrder: "Swiv kòmand",
    locateStore: "Jwenn yon magazen", faq: "FAQ",
    saleBanner: "Sòld −20% sou pwodwi seleksyone",
    inStock: "Disponib", outOfStock: "Pa disponib",
    addToCart: "Mete nan pànye", buyNow: "Achte kounye a",
    viewAll: "Wè tout", viewOffer: "Wè òf la", discover: "Dekouvri",
    profile: "Pwofil", addresses: "Adrès", password: "Modpas",
    orders: "Kòmand", editProfile: "Modifye pwofil",
    changePassword: "Chanje modpas", currentPassword: "Modpas aktyèl",
    newPassword: "Nouvo modpas", save: "Anrejistre", cancel: "Anile",
    fullName: "Non konplè", phone: "Telefòn", city: "Vil", department: "Depatman",
    address: "Adrès", notes: "Nòt", defaultAddress: "Adrès prensipal",
    addAddress: "Ajoute yon adrès", edit: "Modifye", delete: "Efase",
    photo: "Foto", uploadPhoto: "Chanje foto",
    hotDeals: "Òf Cho", featuredProducts: "Pwodwi Chwazi", topSelling: "Pwodwi ki Pi Vann",
    saveUpTo: "Ekonomize jiska", offerEndsIn: "Òf la fini nan:",
    days: "Jou", hours: "Èdt", minutes: "Min", seconds: "Sek",
    specialOffer: "Òf espesyal", bestSellers: "Pi bon vant",
    checkout: "Kòmande", subtotal: "Sou-total", total: "Total", deliveryFee: "Frè livrezon",
    placeOrder: "Konfime kòmand la", promoCode: "Kòd pwomo", apply: "Aplike",
    orderConfirmed: "Kòmand konfime!",
    newArrival: "Nouvo arive", promo: "Pwomo", new: "Nouvo",
    bestSeller: "Pi bon vant", ourStore: "Machin ayisyen pou elektwonik, aparèy elektwomenaje ak enèji solè.",
    pages: "Paj", info: "Enfòmasyon", aboutUs: "Konsènan nou", contactUs: "Kontakte nou",
    helpCenter: "Sant èd", securityCenter: "Sant sekirite", becomePartner: "Vin patnè JE",
    shippingInfo: "Enfòmasyon livrezon", returnPolicy: "Politik retou & ranbousman",
    reportSuspicious: "Rapòte aktivite sispèk", myAccountFooter: "Kont mwen", allRightsReserved: "Tout dwa rezève",
    questionWhatsapp: "Yon kesyon? Ann pale sou WhatsApp",
    teamAnswer: "Ekip nou reponn Lendi jiska Samdi, 8è a 6è",
    contactWhatsapp: "Kontakte nou sou WhatsApp",
    products: "Pwodwi", productsCount: "Pwodwi", reviews: "opinyon",
    remove: "Retire", quantity: "Kantite", emptyCart: "Pànye ou vid",
    startShopping: "Dekouvri pwodwi", cartSummary: "Rezime",
    goToCheckout: "Kontinye achte", myCart: "Pànye mwen",
    shippingAddress: "Adrès livrezon", payment: "Peman",
    yourOrder: "Kòmand ou", processing: "Ap trete…",
    saveOn: "Ekonomize sou pwodwi ou renmen yo",
    hero1Title: "iPhone 15 Pro Max", hero1Sub: "Pisans total. Sistèm foto Pro 48 Mpx.",
    hero2Title: "Batri Lithium", hero2Sub: "6000 sik. Otonomi premye kalite.",
    hero3Title: "Panèl 450W", hero3Sub: "Otonomi konplè pou kay ou.",
    promoActive: "Pwomo aktif", saveUp20: "Ekonomize jiska 20%",
    salesClientPick: "Chwa kliyan yo",
    delivery24: "Livrezon rapid 24è", deliveryGonaives: "Resevwa pwodwi ou 24è nan Gonayiv",
    freeShipping: "Livrezon rapid nan tout Ayiti", trustedSupport: "Sipò WhatsApp 7 jou/7",
    limitedOffer: "Pou kèk jou sèlman! Pwofite pwomosyon eksepsyonèl nou yo.",
    discoverOffers: "Dekouvri òf yo →",
  },
};

const KEY = "je_lang_v1";
export const LANGS = [
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "ht", label: "Kreyòl", flag: "🇭🇹" },
  { code: "en", label: "English", flag: "🇬🇧" },
];

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem(KEY) || "fr");
  useEffect(() => { localStorage.setItem(KEY, lang); document.documentElement.lang = lang; }, [lang]);
  const setLang = (l) => setLangState(l);
  const t = (key) => TRANSLATIONS[lang]?.[key] || TRANSLATIONS.fr[key] || key;
  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
